import { Link } from "react-router-dom";
import SideBarData from "./SideBarData";
import "./NavBar.css";
import illu from "../../illu.png";
import { Image } from "@chakra-ui/react";

function Navbar() {
  return (
    <div>
      <nav className="nav-menu">
        <ul className="nav-menu-items">
          {SideBarData.map((item, index) => {
            return (
              <li key={index} className={item.cName}>
                <Link to={item.path}>
                  {item.icon}
                  <span>{item.title}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <Image
        display={["none", "none", "block", "block"]}
        w={250}
        h={300}
        src={illu}
        style={{ marginTop: "-109.2%" }}
      />
    </div>
  );
}

export default Navbar;
